import React from 'react';
import Icon from '../../../components/AppIcon';

const PayableMetricsCard = ({ 
  title, 
  value, 
  trend, 
  trendValue, 
  icon, 
  status = 'normal',
  subtitle,
  onClick 
}) => {
  const getStatusColor = () => {
    switch (status) {
      case 'success':
        return 'text-success border-success/20 bg-success/5';
      case 'warning':
        return 'text-warning border-warning/20 bg-warning/5';
      case 'error':
        return 'text-error border-error/20 bg-error/5';
      default:
        return 'text-primary border-primary/20 bg-primary/5';
    }
  };

  const getTrendColor = () => {
    if (trend === 'up') return 'text-error'; // For payables, up trend is usually bad
    if (trend === 'down') return 'text-success'; // For payables, down trend is usually good
    return 'text-muted-foreground';
  };

  const getTrendIcon = () => {
    if (trend === 'up') return 'TrendingUp';
    if (trend === 'down') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div 
      className={`
        bg-card border border-border rounded-lg p-6 cursor-pointer
        hover:shadow-card-shadow transition-smooth
        ${onClick ? 'hover:border-primary/30' : ''}
      `}
      onClick={onClick}
    >
      <div className="flex items-start justify-between mb-4">
        <div className={`p-3 rounded-lg ${getStatusColor()}`}>
          <Icon name={icon} size={24} />
        </div>
        
        {trend && (
          <div className={`flex items-center space-x-1 ${getTrendColor()}`}>
            <Icon name={getTrendIcon()} size={16} />
            <span className="text-sm font-body-medium">{trendValue}</span>
          </div>
        )}
      </div>

      <div className="space-y-1">
        <h3 className="text-2xl font-heading-semibold text-card-foreground">
          {value}
        </h3>
        <p className="text-sm font-body-normal text-muted-foreground">
          {title}
        </p>
        {subtitle && (
          <p className="text-xs font-caption text-muted-foreground">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default PayableMetricsCard;